import { rootApi } from "../../api/rootApi";

export const quizApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllQuizzes: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/quiz`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),
    fetchQuizById: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/quiz/${params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
    createQuiz: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/quiz/create`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),
    updateQuiz: builder.mutation({
      query: (params) => ({
        method: "PATCH",
        url: `/tenant/quiz/update/${params.quiz_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),
    changeQuizStatus: builder.mutation({
      query: (params) => ({
        method: "PATCH",
        url: `/tenant/quiz/status/${params.quiz_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),
    getQuizResults: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/quiz/results/${params.quiz_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
  }),
});

export const {
  useFetchAllQuizzesMutation,
  useFetchQuizByIdMutation,
  useCreateQuizMutation,
  useUpdateQuizMutation,
  useChangeQuizStatusMutation,
  useGetQuizResultsMutation,
} = quizApi;
